export default __webpack_public_path__ + "static/media/clock-fast-forward.eca8998b.svg";